<template>
  <v-dialog
    v-model="config.enabled"
    :width="config && (config.title === $t(`common.idleTimeoutTitle`) || config.title === false) ? '510px' : config.width"
    :persistent="config.persistent"
  >
    <v-card outlined v-if="config.title && config.title === 'Session Timeout'" class="pa-4" :class="{ 'border-radius': config.customToolBar, '': !config.customToolBar }">
      <v-card class="ma-4" flat>
        <v-row>
          <v-col cols="2" class=" d-flex align-center justify-center" style="padding-right: 0px; padding-top: 25px;">
            <BaseIcon color="primary" iconClass="justify-center" name="info"/>
              </v-col>
          <v-col style="padding-left: 0px; padding-bottom: 0px; padding-top: 25px;" class="justify-center">
                  <p class="card-title" :style="{ 'font-family': customCSS && customCSS['formSubtitle-fontFamily'] }">{{ config.title }}</p>
              </v-col>
        </v-row>
      <v-card-text
        class="pa-4 pl-15 pt-0 card-content word-wrap"
        :style="{ 'font-family': customCSS && customCSS['formSubtitle-fontFamily'] }"
      >
        <slot name="modalContent" />
        <template v-if="config.content">
          <div>
            <p class="config-content word-wrap"> {{ config.content}} </p>
          </div>
        </template>
        <span
          v-else
          class="modalContent font-weight-regular word-wrap"
          :style="{
            color: customCSS['popUp-content-textColor'] || 'black',
          }"
        >
          {{ config.values }}

        </span>
      </v-card-text>
      <v-card-actions
        v-if="config.saveButton || config.cancelButton"
        class="pa-2"
        :style="{
          color: customCSS['popUp-footer-textColor'],
          'background-color': customCSS['popUp-footer-backgroundColor'],
          'font-family': customCSS['popUp-footer-fontFamily'],
        }"
      >
        <v-spacer />
        <v-btn
          v-if="Boolean(config.saveButton)"
          rounded
          medium
          :color="customCSS['primary']"
          class="save-btn ok-button white--text"
          :style="{ 'font-family': customCSS && customCSS['popUp-button-fontFamily'] }"
          @click="sessionTimeout()"
        >
          {{ config.saveButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-card>
    <v-card outlined v-else-if="config && config.title === false" width="510px" class="pa-4" :class="{ 'border-radius': config.customToolBar, '': !config.customToolBar }">
      <v-card class="ma-4" flat>
        <v-row>
          <v-col cols="10" style="padding-left: 25px; padding-bottom: 0px;" class="d-flex align-center" v-if="config.title !== null && config.title !== ''">
                  <p class="lisa-card-title word-wrap text-none" :style="{ 'font-family': customCSS && customCSS['formTitle-fontFamily'] }">{{ $t('popUp.customerExists') }}</p>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <v-btn rounded text @click="onCancel()">  <BaseIcon name="close"/> </v-btn>
              </v-col>
        </v-row>
      <v-card-text
        class="pa-4 pl-3 pt-2 card-content word-wrap"
        :style="{ 'font-family': customCSS && customCSS['formSubtitle-fontFamily'] }"
      >
        <slot name="modalContent" />
        <template v-if="config.content">
          <div>
            <p class="lisa-card-content word-wrap"> {{ config.content}} </p>
          </div>
        </template>
        <span class="lisa-card-content word-wrap">{{ $t('popUp.contentHelper') }}<br/></span>
        <span class="lisa-card-content word-wrap">{{ $t('popUp.contentHelper1') }}</span>
        <p class="lisa-card-content word-wrap pt-4">{{ $t('popUp.contentHelper2') }}<span class="font-weight-bold"> {{$t(`onboardStatus.helplineNumber`)}}</span> {{$t(`onboardStatus.or`)}} <span class="font-weight-bold">{{$t(`onboardStatus.helplineEmail`)}}.</span></p>
      </v-card-text>
      <v-card-actions
        class="pa-2 pt-6 d-flex justify-end"
        :style="{
          color: customCSS['popUp-footer-textColor'],
          'background-color': customCSS['popUp-footer-backgroundColor'],
          'font-family': customCSS['popUp-footer-fontFamily'],
        }"
      >
        <v-row class="d-flex justify-center">
              <v-col class="mobile-view-review">
                <v-btn
          rounded
          medium
          :color="customCSS['primary']"
          class="save-btn ok-button text-none white--text"
          :style="{ 'font-family': customCSS && customCSS['popUp-button-fontFamily'] }"
          @click="logIn"
        >
          {{ $t('popUp.logIn') }}
        </v-btn>
                <v-btn
          rounded
          medium
          outlined
          :color="customCSS['primary']"
          class="save-btn ok-button text-none"
          :style="{ 'font-family': customCSS && customCSS['popUp-button-fontFamily'] }"
          @click="onCancel"
        >
          {{ $t('popUp.retry') }}
        </v-btn>
              </v-col>
            </v-row>
      </v-card-actions>
    </v-card>
    </v-card>
    <v-card outlined v-else-if="['secondaryApplicantChangeProduct', 'secondaryApplicant','secondaryApplicantResume','accountInformationToBeCaptured', 'changeAccountOwnerShipState'].includes(config.title)" width="510px" class="pa-4" :class="{ 'border-radius': config.customToolBar, '': !config.customToolBar }">
      <v-card class="ma-4" flat>
        <v-row>
          <v-col cols="10" style="padding-left: 25px; padding-bottom: 0px;" class="d-flex align-center" v-if="config.title !== null && config.title !== ''">
                  <p class="lisa-card-title text-none" :style="{ 'font-family': customCSS && customCSS['formTitle-fontFamily'] }">{{ config.title === 'secondaryApplicantResume' ?  $t('messages.secondaryOnboardingResumeTitle') : config.title === 'secondaryApplicantChangeProduct' ? $t('messages.secondaryOnboardingChangeProductTitle') : config.title === 'changeAccountOwnerShipState' ? $t('messages.changeAccountOwnership') : config.title === 'accountInformationToBeCaptured' ? $t('messages.accountOwnershipTitle') : $t('messages.secondaryOnboardingTitle') }}</p>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <v-btn rounded text @click="sessionTimeout()">  <BaseIcon name="close"/> </v-btn>
              </v-col>
        </v-row>
      <v-card-text
        class="pa-4 pl-3 pt-2 card-content word-wrap"
        :style="{ 'font-family': customCSS && customCSS['formSubtitle-fontFamily'] }"
      >
        <slot name="modalContent" />
        <template v-if="config.content">
          <div>
            <p class="lisa-card-content word-wrap"> {{ config.content}} </p>
          </div>
        </template>
        <span class="lisa-card-content word-wrap">{{ config.title === 'secondaryApplicantChangeProduct' ? $t('messages.secondaryOnboardingChangeProductHelper') : config.title === 'changeAccountOwnerShipState' ? $t('messages.changeAccountOwnershipContent') : config.title === 'secondaryApplicantResume' ? $t('messages.secondaryOnboardingResumeContent') : config.title === 'accountInformationToBeCaptured' ? $t('messages.accountOwnershipContent') :  $t('messages.secondaryOnboardingHelper') }}<br/></span>

      </v-card-text>
      <v-card-actions
        class="pa-2 pt-6 d-flex justify-end"
        :style="{
          color: customCSS['popUp-footer-textColor'],
          'background-color': customCSS['popUp-footer-backgroundColor'],
          'font-family': customCSS['popUp-footer-fontFamily'],
        }"
      >
        <v-row class="d-flex justify-center">
          <v-col class="mobile-view-review">
            <v-btn rounded :color="customCSS['primary']" class="save-btn ok-button text-none white--text"
            :style="{ 'font-family': customCSS && customCSS['popUp-button-fontFamily'] }"
             @click="secondaryApplicant(config.title)">
              {{ config.title === 'secondaryApplicantChangeProduct' || config.title === 'changeAccountOwnerShipState' || config.title === 'accountInformationToBeCaptured' ? $t('messages.secondaryOnboardingChangeProductButton') : $t('messages.secondaryOnboardingButton') }}
            </v-btn>
            <v-btn rounded medium text :color="customCSS['primary']" class="save-btn ok-button text-none"
            :style="{ 'font-family': customCSS && customCSS['popUp-button-fontFamily'] }"
            @click="sessionTimeout()">
              {{ $t('common.cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    </v-card>
    <v-card v-else-if="config.values === undefined || (config.values && !config.values.includes('There is no data available for the entered Mobile Number.') && !config.values.includes('There is no pending application found.'))" class="pa-4" :class="{ 'border-radius': config.customToolBar, '': !config.customToolBar }">
      <v-toolbar
        v-if="!config.hideToolbar && !config.customToolBar"
        :color="config.color || customCSS['popUp-header-backgroundColor'] || customCSS['primary']"
        :style="{
          color: customCSS['popUp-header-textColor'] || 'white',
        }"
        class="modalContent"
        :max-height="getCharacterCount(config.title) > 50 ? '100px': '50px'"
      >
        <v-icon class="pb-3 pr-1 white--text material-icons-outlined">{{ config.icon }}</v-icon>
        <span :class="getCharacterCount(config.title) > 50 ? 'pt-6': 'pb-3'" :style="{ 'font-family': customCSS['popUp-header-fontFamily'], 'overflow-wrap': 'anywhere' }">{{
          config.title
        }}</span>
        <v-spacer />
        <span class="pb-3">
          <v-btn v-if="config.close" dark icon class="close-btn" @click="onCancel"
            ><BaseIcon name="close"/></v-btn>
        </span>
      </v-toolbar>
      <div v-else-if="!config.customToolBar" style="overflow-x: hidden;" class="d-flex justify-content-between">
        <span :class="getCharacterCount(config.title) > 50 ? 'titleClass word-wrap pt-4 pl-8 px-3 flex-gap-3': 'titleClass word-wrap pt-4 pl-4 pb-3 flex-gap-3'" :style="{ 'font-family': customCSS['popUp-header-fontFamily'] }">{{
          config.title
        }}</span>
        <v-spacer />
        <span v-if="config.hideToolbar" class="pt-4 pr-6">
          <v-btn v-if="config.close" dark icon class="close-btn" @click="config.title === $t('messages.save.applicationUnavailable') || config.title === $t('messages.save.consentListNotAvailable') || config.title.includes($t('messages.save.invalidProduct')) || config.title.includes($t('messages.save.invalidSubProduct')) ? sessionTimeout() : onCancel()"
            ><BaseIcon name="close"/></v-btn>
        </span>
        <span v-else class="pb-3">
          <v-btn v-if="config.close" dark icon class="close-btn" @click="config.title === $t('messages.save.applicationUnavailable') || config.title === $t('messages.save.consentListNotAvailable') || config.title.includes($t('messages.save.invalidProduct')) || config.title.includes($t('messages.save.invalidSubProduct')) ? sessionTimeout() : onCancel()"
            ><BaseIcon name="close"/></v-btn>
        </span>
      </div>
      <v-toolbar v-if="config.customToolBar" elevation="0">
        <span v-if="config.title" class="titleClass word-wrap pb-0" :style="{ 'font-family': customCSS['popUp-header-fontFamily'], padding: '10px', 'margin-left': '2px' }">{{
          config.title
        }}</span>
        <v-spacer />
        <span class="pb-0" :style="{ padding: '10px', 'margin-left': '9px' }">
          <v-btn v-if="config.close" dark icon class="close-btn" @click="config.title === $t('messages.save.applicationUnavailable') || config.title === $t('messages.save.consentListNotAvailable') || config.title.includes($t('messages.save.invalidProduct')) || config.title.includes($t('messages.save.invalidSubProduct')) ? sessionTimeout() : onCancel()"
            ><BaseIcon name="close"/></v-btn>
        </span>
      </v-toolbar>
      <v-card-text
        class="pa-4 pb-0 pt-0 word-wrap"
        :style="{
          'background-color': customCSS['popUp-content-backgroundColor'],
          'font-family': customCSS['popUp-content-fontFamily'],
          color: customCSS['popUp-content-textColor'] || 'black',
        }"
      >
        <slot name="modalContent" />
        <span v-if="config.showApprovalMsg" class="modalContent font-weight-regular word-wrap black--text">
          <span>
            <BaseIcon color="red" name="report"/>
            {{config.title}}
          </span>
          <v-simple-table dense>
            <thead>
              <tr>
                <th width="50%" scope='col'>{{$t('common.referralDescription')}}</th>
                <th scope='col'>{{$t('common.originatorComments')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{config.content}}</td>
                <td>
                  <v-textarea name="input-7-4" @input="setComments" :value="config.comments" rows=4 outlined autofocus class="mt-6 mb-n5" />
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-spacer/>
        </span>
        <template v-else-if="!config.showApprovalMsg && config.content">
          <div>
            <div class="modal-content" :style="{ 'font-family': customCSS && customCSS['formSubtitle-fontFamily'] }" v-html="config.content"></div>
          </div>
        </template>
        <span
          v-else
          :class=" config.alignCenter ? getCharacterCount(config.title) > 50 ? 'd-flex flex-column flex-gap-3 subtitleClass word-wrap pl-4' : 'd-flex flex-column flex-gap-3 subtitleClass word-wrap pl-1' : 'subtitle-1 font-weight-regular subtitleClass modal-content word-wrap'"
          :style="{
            color: customCSS['popUp-content-textColor'] || 'black',
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }"
        >
          {{ config.values }}

        </span>
      </v-card-text>
      <v-divider v-if="(config.saveButton || config.cancelButton) && config.showDivider" />
      <v-card-actions
        v-if="(config.saveButton || config.cancelButton) && config.hideToolbar && config.deletePopup"
        :class="config.alignCenter ? 'v-card__actions pa-2 justify-center pr-6 pb-6 mobile-view-buttons' : 'pa-2 pr-6 pb-6 mobile-view-buttons'"
        :style="{
          color: customCSS['popUp-footer-textColor'],
          'background-color': customCSS['popUp-footer-backgroundColor'],
          'font-family': customCSS['popUp-footer-fontFamily'],
        }"
      >
        <v-spacer />
        <v-btn
          v-if="config.cancelButton !== 'false' && Boolean(config.cancelButton)"
          :color="customCSS['popUp-delete-cancel-button'] || customCSS['primary']"
          :disabled="config.enableCancel"
          class="font-weight-bold text-none cancel-btn"
          :style="{
            'font-family': customCSS && customCSS['popUp-button-fontFamily']
          }"
          text
          rounded
          @click="onCancel"
        >
          {{ config.cancelButton }}
        </v-btn>
        <v-btn
          v-if="config.saveButton !== 'false' && Boolean(config.saveButton)"
          :color="customCSS['popUp-delete-button'] || customCSS['primary']"
          class="font-weight-light text-none save-btn white--text"
          :style="{
            'font-family': customCSS && customCSS['popUp-button-fontFamily']
          }"
          :disabled="config?.customPopup ? config.customPopup === true ? false : true : false"
          @click="onSave"
          rounded
        >
          {{ config.saveButton }}
        </v-btn>
      </v-card-actions>
      <v-card-actions
        v-if="(config.saveButton || config.cancelButton) && !config.deletePopup"
        :class="config.alignCenter ? 'pa-2 pt-4 justify-center mobile-view-buttons' : 'pr-6 pt-8 mobile-view-buttons'"
        :style="{
          color: customCSS['popUp-footer-textColor'],
          'background-color': customCSS['popUp-footer-backgroundColor'],
          'font-family': customCSS['popUp-footer-fontFamily'],
        }"
      >
        <v-spacer />
        <v-btn
          v-if="config.title && (config.title !== $t('messages.save.applicationUnavailable') && config.title !== $t('messages.save.consentListNotAvailable')) && !config.title.includes('You are already a client') && !config.title.includes('An application pending continuance is already open using these credentials')  && !config.title.includes($t('messages.save.invalidProduct')) && !config.title.includes($t('messages.save.invalidSubProduct')) && !config.title.includes('Eligibility') && config.cancelButton !== 'false' && Boolean(config.cancelButton)"
          :color="customCSS['popUp-cancel-button'] || customCSS['primary']"
          :disabled="config.enableCancel"
          class="font-weight-bold text-none cancel-btn"
          :style="{
            'font-family': customCSS && customCSS['popUp-button-fontFamily']
          }"
          text
          rounded
          @click="onCancel"
        >
        <span>{{ config.cancelButton }} </span>
        </v-btn>
        <v-btn
          v-if="config.saveButton !== 'false' && Boolean(config.saveButton)"
          :color="customCSS['popUp-save-button'] || customCSS['primary']"
          class="font-weight-bold text-none save-btn white--text"
          :style="{
            'font-family': customCSS && customCSS['popUp-button-fontFamily']
          }"
          :disabled="config?.enableSaveButton !== undefined && config?.enableSaveButton !== '' ? config.enableSaveButton === true ? false : true : false"
          @click="config.title === $t('messages.save.applicationUnavailable') || config.title === $t('messages.save.consentListNotAvailable') || config.title.includes($t('messages.save.invalidProduct')) || config.title.includes($t('messages.save.invalidSubProduct')) ? sessionTimeout() : config.title.includes('You are already a client') ? logIn() : config.title.includes('An application pending continuance') ? resumeOnboarding() : onSave()"
          rounded
        >
        <span v-if="config.title && config.title.includes('You are already a client')" class="mb-0"> {{$t(`snackbar.logIn`)}} </span>
        <span v-else-if="config.title && config.title.includes('An application pending continuance')" class="mb-0"> {{$t(`snackbar.resumeOnboarding`)}} </span>
        <span v-else-if="config.title && config.title.includes('Eligibility')" class="mb-0"> {{$t(`snackbar.exit`)}} </span>
        <span v-else-if="config.title && config.title.includes($t('messages.save.invalidProduct'))" class="mb-0"> {{$t(`snackbar.selectProduct`)}}</span>
        <span v-else-if="config.title && (config.title === $t('messages.save.applicationUnavailable') || config.title === $t('messages.save.consentListNotAvailable'))" class="mb-0"> {{$t('messages.save.retry')}} </span>
        <span v-else>{{ config.saveButton }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as colors from '@/_core/util/themeUtility';
import appSettings from '@/plugins/appSettings';
import routeMixin from '@/_core/mixins/routeMixin.js';
import BaseIcon from './common/BaseIcon.vue';
import event from '@/eventBus.js';

export default {
  name: 'Modal',
  mixins: [routeMixin],
  props: {
    config: {
      type: Object,
      default: undefined,
    },
  },
  components: {
    BaseIcon,
  },
  data() {
    return {
      customCSS: {},
    };
  },
  created() {
    this.customCSS = colors.colors;
    if (this.config.hideToolbar) {
      this.showToolbar = false;
    };
    if (this.config.values !== undefined && this.config.values.includes('There is no data available for the entered Mobile Number. ')) {
      this.config.enabled = false;
    } else if (this.config.values !== undefined && this.config.values.includes('LISA')) {
      this.config.enabled = false;
    }
  },
  methods: {
    onSave() {
      this.$emit('save', true);
      this.config.enabled = false;
      if (this.config.saveCallback) {
        this.config.saveCallback();
      }
    },
    onCancel() {
      this.$emit('cancel', true);
      event.$emit('cancel', true);
      if (this.config.cancelCallback) {
        this.config.cancelCallback();
      }
      if (this.config.customToolBar) {
        this.config.customToolBar = false;
        this.config.width = '';
      }
      this.config.enabled = false;
    },
    getCharacterCount(contentString) {
      if (contentString) {
        return contentString.length;
      }
      return false;
    },
    resumeOnboarding() {
      const productType = this.getProductType;
      const productCode = this.getProductCode;
      const productTerm = this.getProductTerm;
      const applicationCode = 'fede';
      const customerOnboarding = 'resume';
      const timeOutUrl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/' + applicationCode + '/' + productType + '/' + productCode + '/' + productTerm + '/' + customerOnboarding;
      window.location = timeOutUrl;
    },
    logIn() {
      const logIn = appSettings.dco.logIn;
      window.location.href = logIn;
    },
    sessionTimeout() {
      const bankProductPage = appSettings.dco.bankProductPage;
      window.location.href = bankProductPage;
    },
    secondaryApplicant(data) {
      if (data === 'secondaryApplicant' || data === 'secondaryApplicantResume') {
        this.config.enabled = false;
        this.$router.push({ params: { action: 'secondaryEligibilityCheck' } });
      } else if (data === 'secondaryApplicantChangeProduct') {
        this.config.enabled = false;
        event.$emit('clearSecondaryApplicantData', true);
      } else if (data === 'accountInformationToBeCaptured') {
        this.config.enabled = false;
        event.$emit('redirectToAccountInformation', true);
      } else if (data === 'changeAccountOwnerShipState') {
        this.config.enabled = false;
        event.$emit('changeAccountOwnership', true);
      }
    },
  },
};
</script>

<style>
.ok-button {
font-size: 12px;
font-weight: 700;
line-height: 18px;
letter-spacing: 1.25px;
}
.card-content {
font-size: 14px;
font-weight: 300 !important;
line-height: 21px;
letter-spacing: 0.25px;
}
.card-title {
font-size: 14px;
font-weight: 500;
line-height: 21px;
letter-spacing: 0.10000000149011612px;
color: rgba(0, 0, 0, 1);
}
.border-radius {
  border-radius: 10px;
}
.subtitleClass {
font-size: 16px;
font-weight: 300;
line-height: 24px;
letter-spacing: 0.5px;
text-align: left;
}
.titleClass {
font-size: 21px;
font-weight: 800 !important;
line-height: 29px;
letter-spacing: 0.5px;
text-align: left;
}
.modal-content {
  font-weight: 300 !important;
  font-size: 16px !important;
  line-height: 3vh !important;
  letter-spacing: 0.5px !important;
  padding-top: 8px;
}
.word-wrap {
  word-break: break-word;
}
@media only screen and (min-width: 320px) and (max-width: 600px) {
  .mobile-view-review {
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center !important;
    max-width: 58.333333% !important;
  }
  .mobile-view-buttons {
    display: flex;
    flex-direction: column-reverse;
    gap: 24px;
  }
}
</style>
